import React, { Component } from "react";
import { useState, useEffect, useRef } from "react";
import * as d3 from "d3";
import moment from "moment";
//const colors = [ '#8ce8ad',  '#27acaa', '#42c9c2', '#60e6e1', '#93f0e6', '#87d3f2', '#4ebeeb', '#35a4e8', '#188ce5', '#542ea5', '#724bc3', '#9c82d4', '#c981b2', '#b14891', '#ff6d00', '#ff810a', '#ff9831', '#ffb46a', '#ff9a91', '#ff736a', '#f95d54', '#ff4136', '#c4c4cd' ];

export default class GanttChartSVGJS extends Component {
  constructor(props) {
    super(props);
    this.chRef = React.createRef();
  }
  // Chart load after component Mount
  componentDidMount() {
    this.drawChart();
  }
  componentDidUpdate() {
    this.drawChart();
  }

  drawChart() {
    var w = 800;
    var h = 400;

    const svgContainer = d3.select(this.chRef.current).node();
    var svg = d3
      .select(this.chRef.current)
      .append("svg")
      .attr("width", w)
      .attr("height", h)
      .attr("class", "svg");
    var taskArray = [
      {
        task: "conceptualize",
        type: "development",
        startTime: "2013-1-28", //year/month/day
        endTime: "2013-2-1",
        details: "This actually didn't take any conceptualization"
      },

      {
        task: "sketch",
        type: "development",
        startTime: "2013-2-1",
        endTime: "2013-2-6",
        details: "No sketching either, really"
      },

      {
        task: "color profiles",
        type: "development",
        startTime: "2013-2-6",
        endTime: "2013-2-9"
      },

      {
        task: "HTML",
        type: "coding",
        startTime: "2013-2-2",
        endTime: "2013-2-6",
        details: "all three lines of it"
      },

      {
        task: "write the JS",
        type: "coding",
        startTime: "2013-2-6",
        endTime: "2013-2-9"
      },

      {
        task: "advertise",
        type: "promotion",
        startTime: "2013-2-9",
        endTime: "2013-2-12",
        details: "This counts, right?"
      },

      {
        task: "spam links",
        type: "promotion",
        startTime: "2013-2-12",
        endTime: "2013-2-14"
      },
      {
        task: "eat",
        type: "celebration",
        startTime: "2013-2-8",
        endTime: "2013-2-13",
        details: "All the things"
      },

      {
        task: "sleep",
        type: "celebration",
        startTime: "2013-3-13",
        endTime: "2013-3-16"
      }
    ];

    // Parse dates
    taskArray.forEach(task => {
      task.startTime = new Date(task.startTime);
      task.endTime = new Date(task.endTime);
    });

    var timeScale = d3
      .scaleTime()
      .domain([
        d3.min(taskArray, function (d) {
          return d.startTime;
        }),
        d3.max(taskArray, function (d) {
          return d.endTime;
        })
      ])
      .range([0, w - 150]);

    var categories = [];

    for (var i = 0; i < taskArray.length; i++) {
      categories.push(taskArray[i].type);
    }

    var catsUnfiltered = categories;

    categories = checkUnique(categories);

    makeGant(taskArray, w, h);
 
    var colorScale = d3
      .scaleOrdinal()
      .domain(categories)
      .range(d3.schemeCategory10);
    drawFlowLines(taskArray, w, h);
    var title = svg
      .append("text")
      .text("Gantt Chart Process")
      .attr("x", w / 2)
      .attr("y", 25)
      .attr("text-anchor", "middle")
      .attr("font-size", 18)
      .attr("fill", "#009FFC");


    function makeGant(tasks, pageWidth, pageHeight) {

      var barHeight = 20;
      var gap = barHeight + 4;
      var topPadding = 75;
      var sidePadding = 75;

      var colorScale = d3.scaleLinear()
        .domain([0, categories.length])
        .range(["#00B9FA", "#F95002"])
        .interpolate(d3.interpolateHcl);



      var grid = svg.append('g')
        .attr('class', 'grid')
        .attr('transform', 'translate(' + sidePadding + ', ' + (h - 50) + ')')
        .call(d3.axisTop(timeScale).ticks(d3.timeWeek.every(1)))
        .selectAll("text")
        .style("text-anchor", "middle")
        .attr("fill", "#000")
        .attr("stroke", "none")
        .attr("font-size", 10)
        .attr("dy", "1em");
      drawRects(tasks, gap, topPadding, sidePadding, barHeight, colorScale, pageWidth, pageHeight);
      vertLabels(gap, topPadding, sidePadding, barHeight, colorScale);

    }


    function drawRects(theArray, theGap, theTopPad, theSidePad, theBarHeight, theColorScale, w, h) {

      var bigRects = svg.append("g")
        .selectAll("rect")
        .data(theArray)
        .enter()
        .append("rect")
        .attr("x", 0)
        .attr("y", function (d, i) {
          return i * theGap + theTopPad - 2;
        })
        .attr("width", function (d) {
          return w - theSidePad / 2;
        })
        .attr("height", theGap)
        .attr("stroke", "none")
        .attr("fill", function (d) {
          for (var i = 0; i < categories.length; i++) {
            if (d.type == categories[i]) {
              return d3.rgb(theColorScale(i));
            }
          }
        })
        .attr("opacity", 0.2);


      var rectangles = svg.append('g')
        .selectAll("rect")
        .data(theArray)
        .enter();


      var innerRects = rectangles.append("rect")
        .attr("rx", 3)
        .attr("ry", 3)
        .attr("x", function (d) {
          return timeScale((d.startTime)) + theSidePad;
        })
        .attr("y", function (d, i) {
          return i * theGap + theTopPad;
        })
        .attr("width", function (d) {
          return (timeScale((d.endTime)) - timeScale((d.startTime)));
        })
        .attr("height", theBarHeight)
        .attr("stroke", "none")
        .attr("fill", function (d) {
          for (var i = 0; i < categories.length; i++) {
            if (d.type == categories[i]) {
              return d3.rgb(theColorScale(i));
            }
          }
        })


      var rectText = rectangles.append("text")
        .text(function (d) {
          return d.task;
        })
        .attr("x", function (d) {
          return (timeScale(d.endTime) - timeScale((d.startTime))) / 2 + timeScale((d.startTime)) + theSidePad;
        })
        .attr("y", function (d, i) {
          return i * theGap + 14 + theTopPad;
        })
        .attr("font-size", 11)
        .attr("text-anchor", "middle")
        .attr("text-height", theBarHeight)
        .attr("fill", "#fff");


      rectText.on('mouseover', function (e) {
        // console.log(this.x.animVal.getItem(this));
        var tag = "";

        if (d3.select(this).data()[0].details != undefined) {
          tag = "Task: " + d3.select(this).data()[0].task + "<br/>" +
            "Type: " + d3.select(this).data()[0].type + "<br/>" +
            "Starts: " + d3.select(this).data()[0].startTime + "<br/>" +
            "Ends: " + d3.select(this).data()[0].endTime + "<br/>" +
            "Details: " + d3.select(this).data()[0].details;
        } else {
          tag = "Task: " + d3.select(this).data()[0].task + "<br/>" +
            "Type: " + d3.select(this).data()[0].type + "<br/>" +
            "Starts: " + d3.select(this).data()[0].startTime + "<br/>" +
            "Ends: " + d3.select(this).data()[0].endTime;
        }
        var output = document.getElementById("tag");
        var rect = this.getBoundingClientRect(); // Get bounding rect of the text element

        // Adjust the position based on the bounding rect of the text element
        var x = rect.left + window.scrollX + rect.width / 2 + "px";
        var y = rect.top + window.scrollY + rect.height + 5 + "px";

        output.innerHTML = tag;
        output.style.top = y;
        output.style.left = x;
        output.style.display = "block";
      }).on('mouseout', function () {
        var output = document.getElementById("tag");
        output.style.display = "none";
      });


      innerRects.on('mouseover', function (e) {
        //console.log(this);
        var tag = "";

        if (d3.select(this).data()[0].details != undefined) {
          tag = "Task: " + d3.select(this).data()[0].task + "<br/>" +
            "Type: " + d3.select(this).data()[0].type + "<br/>" +
            "Starts: " + d3.select(this).data()[0].startTime + "<br/>" +
            "Ends: " + d3.select(this).data()[0].endTime + "<br/>" +
            "Details: " + d3.select(this).data()[0].details;
        } else {
          tag = "Task: " + d3.select(this).data()[0].task + "<br/>" +
            "Type: " + d3.select(this).data()[0].type + "<br/>" +
            "Starts: " + d3.select(this).data()[0].startTime + "<br/>" +
            "Ends: " + d3.select(this).data()[0].endTime;
        }
        var output = document.getElementById("tag");

        var rect = this.getBoundingClientRect(); // Get bounding rect of the text element

        // Adjust the position based on the bounding rect of the text element
        var x = rect.left + window.scrollX + rect.width / 2 + "px";
        var y = rect.top + window.scrollY + rect.height + 5 + "px";


        output.innerHTML = tag;
        output.style.top = y;
        output.style.left = x;
        output.style.display = "block";
      }).on('mouseout', function () {
        var output = document.getElementById("tag");
        output.style.display = "none";

      });



    }


    function makeGrid(theSidePad, theTopPad, w, h) {


    }

    function vertLabels(theGap, theTopPad, theSidePad, theBarHeight, theColorScale) {
      var numOccurances = new Array();
      var prevGap = 0;

      for (var i = 0; i < categories.length; i++) {
        numOccurances[i] = [categories[i], getCount(categories[i], catsUnfiltered)];
      }

      var axisText = svg.append("g") //without doing this, impossible to put grid lines behind text
        .selectAll("text")
        .data(numOccurances)
        .enter()
        .append("text")
        .text(function (d) {
          return d[0];
        })
        .attr("x", 10)
        .attr("y", function (d, i) {
          if (i > 0) {
            for (var j = 0; j < i; j++) {
              prevGap += numOccurances[i - 1][1];
              // console.log(prevGap);
              return d[1] * theGap / 2 + prevGap * theGap + theTopPad;
            }
          } else {
            return d[1] * theGap / 2 + theTopPad;
          }
        })
        .attr("font-size", 11)
        .attr("text-anchor", "start")
        .attr("text-height", 14)
        .attr("fill", function (d) {
          for (var i = 0; i < categories.length; i++) {
            if (d[0] == categories[i]) {
              //  console.log("true!");
              return d3.rgb(theColorScale(i)).darker();
            }
          }
        });

    }

    //from this stackexchange question: http://stackoverflow.com/questions/1890203/unique-for-arrays-in-javascript
    function checkUnique(arr) {
      var hash = {}, result = [];
      for (var i = 0, l = arr.length; i < l; ++i) {
        if (!hash.hasOwnProperty(arr[i])) { //it works with objects! in FF, at least
          hash[arr[i]] = true;
          result.push(arr[i]);
        }
      }
      return result;
    }

    //from this stackexchange question: http://stackoverflow.com/questions/14227981/count-how-many-strings-in-an-array-have-duplicates-in-the-same-array
    function getCounts(arr) {
      var i = arr.length, // var to loop over
        obj = {}; // obj to store results
      while (i) obj[arr[--i]] = (obj[arr[i]] || 0) + 1; // count occurrences
      return obj;
    }

    // get specific from everything
    function getCount(word, arr) {
      return getCounts(arr)[word] || 0;
    }
    function drawFlowLines(tasks, pageWidth, pageHeight) {
      var lineFunction = d3.line()
        .x(function (d) { return d.x; })
        .y(function (d) { return d.y; })
        .curve(d3.curveLinear);
    
      var marker = svg.append("defs").append("marker")
        .attr("id", "arrowhead")
        .attr("viewBox", "0 -5 10 10")
        .attr("refX", 8)
        .attr("refY", 0)
        .attr("markerWidth", 6)
        .attr("markerHeight", 6)
        .attr("orient", "auto")
        .append("path")
        .attr("d", "M0,-5L10,0L0,5")
        .attr("fill", "#666");
    
      var flowData = [];
      categories.forEach(category => {
        var categoryTasks = tasks.filter(task => task.type === category);
        for (var i = 0; i < categoryTasks.length - 1; i++) {
          flowData.push({
            source: {
              x: timeScale(categoryTasks[i].endTime) + 75,
              y: i * 24 + 84 // Adjust this value based on your task height and gap
            },
            target: {
              x: timeScale(categoryTasks[i + 1].startTime) + 75,
              y: (i + 1) * 24 + 84 // Adjust this value based on your task height and gap
            }
          });
        }
      });
    
      var flowLines = svg.selectAll("path.flowline")
        .data(flowData)
        .enter().append("path")
        .attr("class", "flowline")
        .attr("d", function (d) { return lineFunction([d.source, d.target]); })
        .attr("stroke", function (d) {
          return colorScale(tasks.find(task => timeScale(task.endTime) + 75 === d.source.x).type);
        })
        .attr("stroke-width", "2")
        .attr("fill", "none")
        .attr("marker-end", "url(#arrowhead)");
    }
    
  }

  render() {
    return (
      <>
        <div>
          <div ref={this.chRef}></div>
          <div id="tag"></div>
        </div>
      </>
    );
  }
}
